import { SUBSCRIPTIONS_PUBLIC_CONTROLLER_ROOT_PATH } from "./root";

export const SUBSCRIPTIONS_PUBLIC_GET_FRESH_PRICING_INFO_METHOD = "GET";
export const SUBSCRIPTIONS_PUBLIC_GET_FRESH_PRICING_INFO_PATH_SUFFIX = "/fresh/pricing";
export const SUBSCRIPTIONS_PUBLIC_GET_FRESH_PRICING_INFO_PATH = `${SUBSCRIPTIONS_PUBLIC_CONTROLLER_ROOT_PATH}${SUBSCRIPTIONS_PUBLIC_GET_FRESH_PRICING_INFO_PATH_SUFFIX}`;
